export enum Sector {
  Energy = 'Energy',
  Transport = 'Transport',
  Industry = 'Industry (IPPU)',
  Agriculture = 'Agriculture',
  Forestry = 'Forestry',
  WaterAndSanitation = 'Water and Sanitation',
  LandUse = 'Land Use',
  CrossCutting = 'Cross-cutting',
  Other = 'Other',
}
